export const DsDatePickerDefaultProps = {
    orientation: 'portrait',
    closeOnSelect: false,
    format: 'dd/MM/yyyy',
    name: '',
    valueType: 'date',
    fixedWeekNumber: 6
};
